@if (!isTruncated) {
  <div class="app-avatar" [ngClass]="['app-avatar--color-' + color, 'app-avatar--' + size]">
    @if (type === 'initials') {
      <p class="app-avatar__initials">
        {{ name | appAvatarInitials }}
      </p>
    } @else {
      @if (imageUrl) {
        <img class="app-avatar__image" [src]="imageUrl" draggable="false" alt="avatar image" />
      } @else {
        <mat-icon class="app-avatar__icon" svgIcon="user"></mat-icon>
      }
    }
  </div>
}
